import $ from "jquery";

export const setImageSrc = (id: string, src: string) =>
  $(`#image-${id}`).attr("src", src);
